import { render } from "./Circular.vue?vue&type=template&id=6f1e6c4c&scoped=true"
import script from "./Circular.vue?vue&type=script&lang=js"
export * from "./Circular.vue?vue&type=script&lang=js"

import "./Circular.vue?vue&type=style&index=0&id=6f1e6c4c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1e6c4c"]])

export default __exports__